/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import SVGScalingBase from './SVGScalingBase';

const SVGScaling: React.FC<Omit<any, 'isDarkMode'>> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const isDarkMode: boolean = useSelector(getIsDarkModeSelector);

  return <SVGScalingBase {...props} isDarkMode={isDarkMode} />;
};

export default SVGScaling;
